import styled from 'styled-components';

export const TripInfoDetailsInnerWrap = styled.div(
    props => `
        width: 100%;
        display: flex;
        flex-direction: column;
    `
);

export const TripDetailOuterWrap = styled.div(
    props => `
        width:75%;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        position: relative;
    `
);

export const TripRefundStatus = styled.div(
    props => `
        position: absolute;
        top: 1.5rem;
        left:3rem;
        width: 72%;
        display: flex;
        height: .5rem;
        background-color: ${props.theme.colors.grey.lighte7};
    `
);

export const TripRefundStatusFilled = styled.div(
    props => `
        width: ${props.width};
        display: flex;
        height: .5rem;
        background-image: linear-gradient(269deg, #f09819, #f3d452);
    `
);

export const RefundInfoBlock = styled.div(
    props => `
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    `
);

export const RefundSatusTickWrap = styled.div(
    props => `
        width: 3.2rem;
        height: 3.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background-image: linear-gradient(225deg, #f09819, #f3d452);
        border-radius: ${props.theme.misc.borderRadius.round};
        margin-bottom: ${props.theme.spacing.base};
        z-index: 1;
        position: relative;
    `
);

export const RefundStatusFilled = styled.div(
    props => `
        position: absolute;
        width: 19rem;
        height: 5px;
        background-image: linear-gradient(225deg, #f09819, #f3d452);
        left: 0px;
    `
);

export const RefundStatusEmpty = styled.div(
    props => `
        position: absolute;
        width: 19rem;
        height: 5px;
        background-color: ${props.theme.colors.grey.lighte7};
        left: 0px;
    `
)

export const RefundSatusCountWrap = styled.div(
    props => `
        width: 3.2rem;
        height: 3.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${props.theme.colors.grey.lighte7};
        border-radius: ${props.theme.misc.borderRadius.round};
        margin-bottom: ${props.theme.spacing.base};
        z-index: 1;
    `
);

export const RefundStatusCountText = styled.p(
    props => `
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.grey.dark74};
        font-weight: ${props.theme.font.fontWeight.bold};
    `
);

export const RefundStatusTextWrap = styled.div(
    props => `
        display: flex;
        flex-direction: column;
    `
);

export const BkngStatus = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.grey.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        padding-bottom: ${props.theme.spacing.small.s5};
    `
);

export const RefundStatTime = styled.p(
    props => `
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.grey.base};
        font-weight: ${props.theme.font.fontWeight.bold};
    `
)

export const TripAdditionInfoWrap = styled.div(
    props => `
        display: flex;
        align-items: center;
        padding-top: ${props.theme.spacing.large.l25};
    `
);

export const RefundStatus = styled.div(
    props => `
        display: flex;
        background-color: ${props.theme.colors.yellow.bgLightff};
        padding: ${props.theme.spacing.base};
        border-radius: ${props.theme.misc.borderRadius.base};
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.yellow.darkcf};
        font-weight: ${props.theme.font.fontWeight.bold};
    `
);